import { components, PlaceholderProps } from 'react-select';
import { useFormContext, useWatch } from 'react-hook-form';
import { FormType } from '../../../shared/models/form';
import { useTranslation } from 'react-i18next';

interface CustomPlaceholderProps {
  placeholderProps: PlaceholderProps;
}

export const CustomPlaceholder = ({ placeholderProps }: CustomPlaceholderProps) => {
  const { control } = useFormContext<FormType>();
  const [adults, children, infants] = useWatch({
    control,
    name: ['adults', 'children', 'infants'],
  });
  const { t } = useTranslation();

  const passengerText = [
    { plural: t('adults'), singular: t('adult'), num: adults },
    { plural: t('children'), singular: t('child'), num: children },
    { plural: t('infants'), singular: t('infant'), num: infants },
  ]
    .filter((passenger) => passenger.num > 0)
    .map(({ plural, singular, num }) => `${num} ${num > 1 ? plural : singular}`)
    .join(', ');

  return (
    <components.Placeholder {...placeholderProps}>
      <span className="text-black truncate">{passengerText}</span>
    </components.Placeholder>
  );
};

export default CustomPlaceholder;
